import app from "./app.json" with { type: "json" };
import auth from "./auth.json" with { type: "json" };
import bank from "./bank.json" with { type: "json" };
import cards from "./cards.json" with { type: "json" };
import common from "./common.json" with { type: "json" };
import consultantAuth from "./consultantAuth.json" with { type: "json" };
import consultantBank from "./consultantBank.json" with { type: "json" };
import consultantBooks from "./consultantBooks.json" with { type: "json" };
import consultantCards from "./consultantCards.json" with { type: "json" };
import consultantApprovals from "./consultantApprovals.json" with { type: "json" };
import consultantDraft from "./consultantDraft.json" with { type: "json" };
import consultantErrors from "./consultantErrors.json" with { type: "json" };
import consultantExpenses from "./consultantExpenses.json" with { type: "json" };
import consultantMessages from "./consultantMessages.json" with { type: "json" };
import consultantMatching from "./consultantMatching.json" with { type: "json" };
import consultantOnboarding from "./consultantOnboarding.json" with { type: "json" };
import consultantPayables from "./consultantPayables.json" with { type: "json" };
import consultantPayments from "./consultantPayments.json" with { type: "json" };
import consultantReceivables from "./consultantReceivables.json" with { type: "json" };
import consultantReview from "./consultantReview.json" with { type: "json" };
import consultantSettings from "./consultantSettings.json" with { type: "json" };
import consultantShell from "./consultantShell.json" with { type: "json" };
import consultantShowAndTell from "./consultantShowAndTell.json" with { type: "json" };
import consultantTax from "./consultantTax.json" with { type: "json" };
import consultantTodos from "./consultantTodos.json" with { type: "json" };
import consultantToasts from "./consultantToasts.json" with { type: "json" };
import consultantTransactions from "./consultantTransactions.json" with { type: "json" };
import consultantUpload from "./consultantUpload.json" with { type: "json" };
import consultantInvoiceCreate from "./consultantInvoiceCreate.json" with { type: "json" };
import documents from "./documents.json" with { type: "json" };
import emails from "./emails.json" with { type: "json" };
import errors from "./errors.json" with { type: "json" };
import feedback from "./feedback.json" with { type: "json" };
import invoices from "./invoices.json" with { type: "json" };
import messages from "./messages.json" with { type: "json" };
import onboarding from "./onboarding.json" with { type: "json" };
import payment from "./payment.json" with { type: "json" };
import profile from "./profile.json" with { type: "json" };
import settings from "./settings.json" with { type: "json" };
import shell from "./shell.json" with { type: "json" };
import tax from "./tax.json" with { type: "json" };
import todos from "./todos.json" with { type: "json" };
import todoText from "./todoText.json" with { type: "json" };
import userManagement from "./userManagement.json" with { type: "json" };

export default {
  app,
  auth,
  bank,
  cards,
  common,
  consultantAuth,
  consultantBank,
  consultantBooks,
  consultantCards,
  consultantInvoiceCreate,
  consultantOnboarding,
  consultantReceivables,
  consultantTax,
  consultantTransactions,
  consultantApprovals,
  consultantDraft,
  consultantErrors,
  consultantExpenses,
  consultantMessages,
  consultantMatching,
  consultantPayables,
  consultantPayments,
  consultantReview,
  consultantSettings,
  consultantShell,
  consultantShowAndTell,
  consultantTodos,
  consultantToasts,
  consultantUpload,
  documents,
  emails,
  errors,
  feedback,
  invoices,
  messages,
  onboarding,
  payment,
  profile,
  settings,
  shell,
  tax,
  todos,
  todoText,
  userManagement,
};
